module.exports = __webpack_public_path__ + "img/Team-AlexPiliptchak.5f4902c2.png";